import axios from 'axios'

// 创建 axios 实例
const request = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'https://api.botchat.top',
    timeout: 300000,
    headers: {
        'Content-Type': 'application/json'
    }
})

// 请求拦截器
request.interceptors.request.use(
    config => {
        // 添加token到请求头
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['token'] = token
        }
        
        // 确保URL参数正确编码
        if (config.params) {
            const encodedParams = {}
            Object.keys(config.params).forEach(key => {
                const value = config.params[key]
                if (value !== null && value !== undefined) {
                    encodedParams[key] = value
                }
            })
            config.params = encodedParams
        }
        
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
request.interceptors.response.use(
    response => {
        const res = response.data
        
        // 更新token
        const newToken = response.headers['token']
        if (newToken) {
            localStorage.setItem('token', newToken)
        }
        
        if (res.code == 200) {
            return res
        } else {
            // token过期或无效，跳转到登录页
            if (res.code == 500001 || res.msg == '请先登录！') {
                localStorage.removeItem('token')
                window.location.reload()
                return Promise.reject(new Error('登录已过期，请重新登录'))
            }
            return Promise.reject(new Error(res.msg || res.message || '请求失败'))
        }
    },
    error => {
        // 401或403错误，清除token并刷新页面
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            localStorage.removeItem('token')
            window.location.reload()
            return Promise.reject(new Error('登录已过期，请重新登录'))
        }
        return Promise.reject(error)
    }
)

export default request